module.exports = __webpack_public_path__ + "static/linkedin-91dc13219dfb6e382f6e504cf101d49b.jpg";